import { render, staticRenderFns } from "./Factors-Single.vue?vue&type=template&id=2cd50caa&scoped=true"
import script from "./Factors-Single.js?vue&type=script&lang=js&external"
export * from "./Factors-Single.js?vue&type=script&lang=js&external"
import style0 from "./Factors-Single.vue?vue&type=style&index=0&id=2cd50caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd50caa",
  null
  
)

export default component.exports